"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.tabs.threads': 'Wątki',
    'whatsapp.tabs.settings': 'Ustawienia',
    'whatsapp.tabs.groups': 'Grupy',
    'whatsapp.tabs.directMessages': 'Wiadomości bezpośrednie',
    'whatsapp.tabs.email': 'E-mail',
    'whatsapp.tabs.emailSettings': 'Ustawienia e-mail',
};
